import { getClientCustomFetch } from '../lib/getClientCustomFetch'
import { getUrlStringFromParamObject } from '../lib/api'

const getProducts = async (
  data = {},
  options = {},
  themeName,
  isMarketPlace
) => {
  const customFetch = await getClientCustomFetch()
  const { params = {} } = data
  if (isMarketPlace) {
    params.source = 'seller'
  }
  const { baseURL = '', storeId } = options
  const url = `/product`
  const config = {
    ...params,
    ...(themeName === 'Getz' && { delimiter: '|' }),
  }

  const response = await customFetch.get(
    getUrlStringFromParamObject(url, { ...config, storeId }),
    {
      headers: {
        excludeAuth: true,
      },
    }
  )
  return response?.data
}

const getProductsBySlug = async (data = {}, options = {}) => {
  const customFetch = await getClientCustomFetch()
  const { slug = '', storeId, themeName } = options

  let url =
    themeName === 'Getz'
      ? `/layout/product?url=${slug}&includeTagDetails=true`
      : `/layout/product?url=${slug}`
  if (storeId) {
    url = `${url}&storeId=${storeId}`
  }
  const response = await customFetch.get(getUrlStringFromParamObject(url, data))
  return response?.data
}

const getBrands = async (data = {}, options = {}) => {
  const customFetch = await getClientCustomFetch()
  const { brandName = '', params = {} } = data
  const { baseURL = '', storeId } = options
  let url = `${baseURL}/layout/brand?url=${brandName}`
  delete params?.brand
  delete data?.brandName
  console.log('url', url)
  if (storeId) {
    url = `${url}&storeId=${storeId}`
  }
  const response = await customFetch.get(
    getUrlStringFromParamObject(url, data),
    { headers: { excludeAuth: true } }
  )
  return response?.data
}

const getManufacturers = async (data = {}, options = {}) => {
  const customFetch = await getClientCustomFetch()
  const { params = {} } = data
  const { Manufacturer = '' } = params
  const { baseURL = '' } = options
  delete params?.Manufacturer
  const url = `/public/layout/manufacturer?url=${encodeURIComponent(
    Manufacturer
  )}`

  const response = await customFetch.get(url, {
    headers: { excludeAuth: true },
  })
  return response?.data
}

const getCategories = async (data = {}, options = {}, filter = '') => {
  const customFetch = await getClientCustomFetch()
  const { categoryName = '', params = {} } = data
  const { baseURL = '', storeId } = options
  let url = `/layout/category?url=${filter ? filter : categoryName}`
  if (storeId) {
    url = `${url}&storeId=${storeId}`
  }
  if (params.includeCategory !== undefined) {
    url = `${url}&includeCategory=${params.includeCategory}`
  }
  const response = await customFetch.get(url, {
    headers: { excludeAuth: true },
  })
  return response?.data
}

const getTags = async (data = {}, options = {}) => {
  const customFetch = await getClientCustomFetch()
  const { tagName = '' } = data
  const { baseURL = '', storeId } = options
  let url = `${baseURL}/layout/tag?url=${tagName}`
  if (storeId) {
    url = `${url}&storeId=${storeId}`
  }
  const response = await customFetch.get(url, {
    headers: { excludeAuth: true },
  })
  return response?.data?.page
}

const getSearchResults = async (data = {}, options = {}) => {
  const customFetch = await getClientCustomFetch()
  const { params = {} } = data
  const { baseURL = '', storeId, isMarketPlace } = options
  let url = `/layout/search?q=${params.q}`
  if (storeId) {
    url = `${url}&storeId=${storeId}`
  }
  if (isMarketPlace) {
    url = `${url}&source=seller`
  }
  const response = await customFetch.get(url, {
    headers: { excludeAuth: true },
  })
  return response?.data?.page
}

const allCategories = async (data = {}, options = {}) => {
  const customFetch = await getClientCustomFetch()
  const { baseURL = '', storeId } = options
  let url = `/category`
  if (storeId) {
    url = `${url}?storeId=${storeId}`
  }
  const response = await customFetch.get(url, {
    headers: { excludeAuth: true },
  })
  return response?.data
}

const allBrands = async (data = {}, options = {}) => {
  const customFetch = await getClientCustomFetch()
  const { baseURL = '', storeId } = options
  let url = `/brand`
  if (storeId) {
    url = `${url}?storeId=${storeId}`
  }
  const response = await customFetch.get(url, {
    headers: { excludeAuth: true },
  })
  return response?.data
}

const allManufacturers = async (options = {}) => {
  const customFetch = await getClientCustomFetch()
  const { baseURL = 'public' } = options
  const url = `/public/manufacturer`
  const response = await customFetch.get(url, {
    headers: { excludeAuth: true },
  })
  return response?.data
}

const getSellerProductsBySlug = async (data = {}, options = {}) => {
  const customFetch = await getClientCustomFetch()
  const { slug = '', storeId, sellerId } = options

  let url = `/layout/product?url=${slug}&sellerID=${sellerId}`
  if (storeId) {
    url = `${url}&storeId=${storeId}`
  }
  const response = await customFetch.get(
    getUrlStringFromParamObject(url, data),
    { headers: { excludeAuth: true } }
  )
  return response?.data
}

const organizationDataFetch = async (domain) => {
  const response = await fetch(`${domain}/organization`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    cache: 'force-cache',
  })
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }
  const data = await response.json()
  return data?.data
}

const getOrganizationData = async () => {
  let domain
  if (typeof window === 'undefined') {
    domain = `${process.env.NEXT_PUBLIC_DOMAIN_URL}/api`
  }
  try {
    const organizationData = await organizationDataFetch(domain)
    return organizationData
  } catch (error) {
    console.error('Error fetching organization data:', error)
    throw error
  }
}

const seller = async (options) => {
  const customFetch = await getClientCustomFetch()
  const { storeId, sellerSlug } = options
  const response = await customFetch.get(
    `/layout/seller?storeId=${storeId}&url=${sellerSlug}`
  )
  return response?.data?.page
}

export {
  getProducts,
  getProductsBySlug,
  getBrands,
  getCategories,
  getTags,
  getSearchResults,
  getManufacturers,
  allCategories,
  allBrands,
  allManufacturers,
  getSellerProductsBySlug,
  getOrganizationData,
  seller,
}
